import React, { Component } from 'react';
import gql from 'graphql-tag';
import cloneDeep from 'lodash/cloneDeep';
import { compose, graphql, withApollo } from 'react-apollo';
// import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';
import Tab from 'react-bootstrap/Tab';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { SELECTION_EVENT, trackUserEvent } from 'userActivityMiddleware';
import { SUBSCRIPTION_PREFERRED_LOCATION_CHANGED } from 'containers/DesktopNotificationTray';
import HomeIconExit from 'components/HomeExitIcon';
import LoadingIndicator from 'components/LoadingIndicator';
import PageTitleBar from 'components/PageTitleBar';
import SafeMarkdown from 'components/SafeMarkdown';
import TabView from 'components/TabView';
import { LG_BREAKPOINT_AND_UP } from 'utils/constants';
import { augmentDrawing } from 'utils/drawings';
import { getUserData } from 'utils/graphQLFunctions';
import withMediaQuery from 'utils/withMediaQuery';
import DrawingCarousel from './Carousel';
import PastWinners from './PastWinners';
import { updateDrawings } from './utils/cacheHandling';
import { getDrawingsQuery } from './utils/common';
import {
  addDrawingEvent,
  addDrawingEvents,
  selectLastEvent,
  updateLastDrawingEvent
} from './utils/eventReducer';
import DrawingsIcon from './assets/Button-Drawings.svg';
import './Drawings.css';

export const LOBBY_TAB = 'lobby';
export const MY_DRAWINGS_TAB = 'my-drawings';
export const PAST_DRAWINGS_TAB = 'past-drawings';
export const ELIGIBITLITY = 'terms-eligibility';

const TABS = [
  { key: LOBBY_TAB, title: 'Lobby' },
  { key: MY_DRAWINGS_TAB, title: 'My Drawings' },
  { key: PAST_DRAWINGS_TAB, title: 'Past Drawings' },
  { key: ELIGIBITLITY, title: 'Terms & Eligibility' }
];

class DrawingsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      requested: false,
      activeDrawing: false,
      selectedTab: 1,
      promoIndex: 0,
      myIndex: 0,
      lastUrl: ''
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleViewAction = this.handleViewAction.bind(this);
    this.handlePromoSelection = this.handlePromoSelection.bind(this);
    this.handleMySelection = this.handleMySelection.bind(this);
    this.handleSelectTab = this.handleSelectTab.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (state.lastUrl === props.match.url) {
      return {};
    }
    const drawingId = props.match.params.drawingId;
    const newState = {};
    if (
      drawingId &&
      (!state.activeDrawing || state.activeDrawing.id !== drawingId) &&
      props.commonDrawings.length
    ) {
      newState.lastUrl = props.match.url;
      const found = props.commonDrawings.find(d => d.id === drawingId);
      if (found) {
        newState.activeDrawing = found;
      } else {
        newState.selectedTab = 3;
      }
    }
    return newState;
  }

  componentDidMount() {
    this.unSubscribeToScrollUpdates = this.props.subscribeToScrollUpdates(
      this.props
    );
    this.unsubscribeLobbyFromLocationData =
      this.props.subscribeLobbyToLocationData();
    this.unsubscribeMyDrawingFromLocationData =
      this.props.subscribeMyDrawingToLocationData();
  }

  componentWillUnmount() {
    this.unSubscribeToScrollUpdates();
    this.unSubscribeToScrollUpdates = () => {};
    this.unsubscribeLobbyFromLocationData = () => {};
    this.unsubscribeMyDrawingFromLocationData = () => {};
  }

  componentDidUpdate(prevProps) {
    const last = this.props.lastDrawingEvent;
    if (
      !last ||
      last.event.processed ||
      last.event.drawingId !== this.state.activeDrawing.id
    ) {
      return;
    }

    last.event.processed = true;
    if (!this.state.activeDrawing || !last.updatedDrawing) {
      return;
    }

    this.setState({
      activeDrawing: last.updatedDrawing.enabled ? last.updatedDrawing : false
    });
  }

  //  ---------------------------------
  checkErrors() {
    return (
      (this.props.commonDrawingsData && this.props.commonDrawingsData.error) ||
      (this.props.myDrawingsData && this.props.myDrawingsData.error) ||
      (this.props.userData && this.props.userData.error)
    );
  }

  checkLoading() {
    return (
      !this.props.commonDrawingsData ||
      this.props.commonDrawingsData.loading ||
      !this.props.myDrawingsData ||
      this.props.myDrawingsData.loading ||
      !this.props.userData ||
      this.props.userData.loading
    );
  }

  //  ---------------------------------
  //  handlers
  handleClose() {
    this.setState({
      show: false
    });
  }

  handleViewAction(drawing = false) {
    this.setState({
      activeDrawing: drawing
    });
  }

  handlePromoSelection(idx) {
    this.setState({ promoIndex: idx });
  }

  handleMySelection(idx) {
    this.setState({ myIndex: idx });
  }

  handleSelectTab(selectedTabValue) {
    trackUserEvent({
      activityType: SELECTION_EVENT,
      eventName: 'select-drawings-tab',
      eventValue: selectedTabValue,
      initiator: 'drawings-tabs'
    });
  }

  //  ---------------------------------
  //  rendering
  renderLoadingIndicator() {
    if (this.state.requested) {
      return <LoadingIndicator overlay />;
    }
  }

  renderPromotionsLobby() {
    const drawings = this.props.commonDrawings;
    if (!drawings || !drawings.length) {
      return (
        <div className="drawings-list-content no-drawings">
          <div>
            <div className="title">No Scheduled Drawings</div>
            <div className="sub-text">
              There aren't any Drawings currently scheduled. Check back soon to
              enter and win great prizes!
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="drawing-carousel-container">
        <DrawingCarousel
          items={drawings}
          onAction={this.handleViewAction}
          index={this.state.promoIndex}
          onSelect={this.handlePromoSelection}
        />
      </div>
    );
  }

  renderMyDrawings() {
    const drawings = this.props.myDrawings;
    return !drawings || !drawings.length ? (
      <div className="drawings-list-content no-drawings">
        <div className="title">No Current Drawings</div>
        <div className="sub-text">
          You aren't entered in any Drawings yet. Head to the Lobby to join a
          Drawing or visit the WStore to get more entries!
        </div>
        <Link
          className="shop-wstore-btn"
          to={{
            pathname: '/wstore',
            state: { categoryValue: 'D - Ticket', initiator: 'shop-wstore-btn' }
          }}
        >
          Shop WStore
        </Link>
      </div>
    ) : (
      <DrawingCarousel
        items={drawings}
        onAction={this.handleViewAction}
        index={this.state.myIndex}
        onSelect={this.handleMySelection}
      />
    );
  }

  renderEligibility() {
    return (
      <div className="eligibility">
        <SafeMarkdown>{this.props.eligibilityText}</SafeMarkdown>
      </div>
    );
  }

  render() {
    if (this.checkLoading()) {
      return null;
    }

    if (this.checkErrors()) {
      return (
        <div className="Drawings-alert">
          <Alert variant="danger">
            <p>
              There was a problem retrieving the list of Drawings. Please try
              again later.
            </p>
          </Alert>
        </div>
      );
    }

    return (
      <div className="drawings-container">
        <Helmet>
          <title>Drawings</title>
        </Helmet>
        <PageTitleBar title="Drawings" icon={DrawingsIcon}></PageTitleBar>
        <h1 className="sr-only">Drawings</h1>
        <div className="drawings-window">
          <div className="drawings-list">
            <TabView
              defaultTab={LOBBY_TAB}
              tabTitles={TABS}
              id="drawings-navigation"
              className="drawings-list-tab-view"
              theme="drawings"
              navClassName="drawings-tabs"
              dropdownClassName="drawings-list-menu"
              matchesBreakpoint={this.props.matchesBreakpoint}
              onSelectTab={this.handleSelectTab}
            >
              <Tab.Content>
                <Tab.Pane eventKey={LOBBY_TAB} mountOnEnter>
                  {this.renderPromotionsLobby()}
                </Tab.Pane>
                <Tab.Pane eventKey={MY_DRAWINGS_TAB} mountOnEnter>
                  {this.renderMyDrawings()}
                </Tab.Pane>
                <Tab.Pane eventKey={PAST_DRAWINGS_TAB} mountOnEnter>
                  <PastWinners />
                </Tab.Pane>
                <Tab.Pane eventKey={ELIGIBITLITY} mountOnEnter>
                  {this.renderEligibility()}
                </Tab.Pane>
              </Tab.Content>
            </TabView>
          </div>
        </div>
        {this.state.activeDrawing && (
          <HomeIconExit onClick={() => this.handleViewAction()} />
        )}
      </div>
    );
  }
}

// DrawingsPage.propTypes = {
//   drawingsEvents: PropTypes.arrayOf(PropTypes.object),
//   lastEvent: PropTypes.object
// };

//  ----------------------------------------------------------------------------------------------//
const QUERY_DRAWING_EVENTS = gql`
  query drawingsEvents {
    drawingsEvents {
      drawingsEvents {
        drawingId
        desc
        date
        name
        event
        user {
          userId
          displayName
          avatarUrl
        }
        rank
        tickets
        prizes {
          prizes {
            name
            url
            category
          }
        }
      }
    }
  }
`;

const SUBSCRIPTION_DRAWING_EVENTS = gql`
  subscription AllDrawingsUpdates {
    allDrawingsUpdates {
      drawingId
      name
      event
      desc
      date
      user {
        userId
        displayName
      }
      rank
      tickets
      prizes {
        prizes {
          name
          url
          category
        }
      }
    }
  }
`;

const QUERY_ELIGIBILITY = gql`
  query eligibility {
    eligibility {
      text
    }
  }
`;

//  ----------------------------------------------------------------------------------------------//
const withData = compose(
  withMediaQuery(LG_BREAKPOINT_AND_UP),
  withApollo,
  graphql(QUERY_DRAWING_EVENTS, {
    options: props => {
      return {
        variables: { input: {} },
        fetchPolicy: 'cache-and-network'
      };
    },
    props: ({ data, ownProps }) => {
      const drawingsEvents =
        (!data.loading &&
          !data.error &&
          data.drawingsEvents &&
          data.drawingsEvents.drawingsEvents) ||
        [];

      ownProps.addDrawingEvents(drawingsEvents);

      return {
        drawingsEventsData: data,
        subscribeToScrollUpdates: props => {
          const { client } = props;
          let user = props.userData.user;
          //  no idea how to guarantee that user is fetched _before_ this code
          if (!user) {
            props.userData.refetch().then(resp => {
              user = resp.data.user;
            });
          }

          return data.subscribeToMore({
            document: SUBSCRIPTION_DRAWING_EVENTS,
            updateQuery: async (prev, { subscriptionData }) => {
              let resp = cloneDeep(prev);

              ownProps.addDrawingEvent(subscriptionData.data);

              const updatedDrawing = await updateDrawings(
                client,
                user.userId,
                subscriptionData.data
              );

              ownProps.updateLastDrawingEvent({
                updatedDrawing,
                event: subscriptionData.data
              });
              return resp;
            },

            onError: e => {
              console.error('SUBSCRIPTION_DRAWING_EVENTS error', e);
            }
          });
        }
      };
    }
  }),
  getUserData({
    name: 'userData'
  }),
  //  lobby
  graphql(getDrawingsQuery(), {
    options: props => ({
      fetchPolicy: 'network-only',
      variables: {
        input: {
          states: ['InProgress', 'Upcoming'],
          onlyMy: false,
          enabled: true
        }
      }
    }),
    props: ({ data, ownProps }) => {
      let drawings = (data.drawings && data.drawings.drawings) || [];

      drawings.forEach(augmentDrawing);

      return {
        commonDrawingsData: data,
        commonDrawings: drawings.sort(
          (lhs, rhs) => lhs.drawTime.getTime() - rhs.drawTime.getTime()
        ),
        subscribeLobbyToLocationData: () => {
          return data.subscribeToMore({
            document: SUBSCRIPTION_PREFERRED_LOCATION_CHANGED,
            updateQuery: prev => {
              data.refetch();
            }
          });
        }
      };
    }
  }),
  //  my drawings
  graphql(getDrawingsQuery(), {
    options: props => ({
      fetchPolicy: 'network-only',
      variables: {
        input: {
          states: ['InProgress', 'Upcoming'],
          onlyMy: true,
          enabled: true
        }
      }
    }),
    props: ({ data, ownProps }) => {
      let drawings = (data.drawings && data.drawings.drawings) || [];
      drawings.forEach(augmentDrawing);

      return {
        myDrawingsData: data,
        myDrawings: drawings.sort(
          (lhs, rhs) => lhs.drawTime.getTime() - rhs.drawTime.getTime()
        ),
        subscribeMyDrawingToLocationData: () => {
          return data.subscribeToMore({
            document: SUBSCRIPTION_PREFERRED_LOCATION_CHANGED,
            updateQuery: prev => {
              data.refetch();
            }
          });
        }
      };
    }
  }),
  graphql(QUERY_ELIGIBILITY, {
    options: props => ({
      fetchPolicy: 'cache-and-network'
    }),
    props: ({ data }) => {
      let eligibilityText = (data.eligibility && data.eligibility.text) || '';
      return { eligibilityText };
    }
  })
)(DrawingsPage);

//  ---------------------------------
const mapDispatchToProps = dispatch => {
  return {
    addDrawingEvents: events => {
      dispatch(addDrawingEvents(events));
    },
    addDrawingEvent: event => {
      dispatch(addDrawingEvent(event));
    },
    updateLastDrawingEvent: event => {
      dispatch(updateLastDrawingEvent(event));
    }
  };
};

const mapStateToProps = state => {
  return {
    lastDrawingEvent: selectLastEvent(state)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withData);

//  event:
//    "created"
//    "updated"
//    "deleted"
//    "refunded"
//    "addTickets"
//    "addFreeTicket"
//    "notifyStart"
//    "start"
//    "round"
//    "winner"
//    "claimed"
//    "end"
